/**
 * File banner-carousel.js
 *
 * Handles Cards with links, making the entire card clickable.
 */

document.addEventListener( 'DOMContentLoaded', function () {
	const backToTopButton = document.querySelector( '.scroll-to-top' );
	if ( backToTopButton ) {
		backToTopButton.addEventListener( 'click', function () {
			window.scrollTo( {
				top: 0,
				behavior: 'smooth',
			} );
		} );
	}
} );
